/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Base class serializer for all OpenAPI serializers.  It only implements create/update method without any logic to prevent \"abstract\" warning by pylint.
 */
export interface BantCalculatedResult { 
    uuid: string;
    ageAdjustedZScore: string;
    isophiScore: string;
    isophiScoreCiLower: string;
    isophiScoreCiUpper: string;
    percentile: number;
    iqScore: number;
    finalThetaEap: string;
    finalThetaSee: string;
    iqScoreLower: string;
    iqScoreUpper: string;
    percentileLower: string;
    percentileUpper: string;
}